import { getApiEnv } from 'core_main/globals/api';
import { CHAT_EVENTS_ENDPOINT } from '../types';
import { getTrackingTokenFromLocalStorage } from '../../helpers/browser';

export const createOptionsWithHeaders = (options) => {
  const trackingToken = getTrackingTokenFromLocalStorage() || '';

  const headers = new Headers({
    'Content-Type': 'application/json',
    'x-kustomer': 'kustomer',
    'x-kustomer-client': 'chat-web',
    'x-kustomer-tracking-token': trackingToken,
    credentials: 'include',
  });

  return {
    ...options,
    headers,
  };
};
/**
 * Needed to create a custom API call to ensure that we don't have circular referencing in our code for API calls
 * @param body
 * @param org
 */
export const eventsApiPost = (body: string, org: string) => {
  if (!org) return Promise.reject(new Error('Missing org'));
  const { protocol, baseUrlDomain } = getApiEnv();
  const endpoint = CHAT_EVENTS_ENDPOINT;

  const options = { body, method: 'POST' };

  let base = `${protocol}://${org}.${baseUrlDomain}${endpoint}`;

  if (
    process.env.NODE_ENV !== 'production' &&
    process.env.DEV_REMOTE_API_BASE_URL
  ) {
    base = `${process.env.DEV_REMOTE_API_BASE_URL}${endpoint}`;
  }

  const optionsWithHeaders = createOptionsWithHeaders(options);

  return fetch(base, optionsWithHeaders);
};
